import { Item } from '@yleisradio/areena-types';
import { useFavoriteUpdate } from './useFavoriteUpdate';

interface Props {
  item: Item | undefined;
}

export const FavoriteUpdate: React.FunctionComponent<Props> = ({ item }) => {
  useFavoriteUpdate(item);
  return null;
};
